export default {
  PRIORITY_ERROR: 'ERROR',
  SIGN_IN_UNSUCCESSFUL: 'SIGN_IN_UNSUCCESSFUL',
  NEED_HELP: 'NEED_HELP',
};

export const MODIFY_RENTAL_ERRORS = {
  CREDIT_CARD: 'FRCLTW00122',
};

/**
 * Service Error codes
 * @returns list of unique gbo or gma error codes
 */

export const HIDE_GMA_GBO_SERVICE_ERROR_CODES = new Set([
  'PRICING_16007',
  'CROS_RES_VEHICLE_NOT_AVAILABLE',
  'GMA_NO_VEHICLES_AVAILABLE',
  'CROS_UPGRADE_VEHICLE_NOT_POSSIBLE',
]);
